"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
function FlowWrapper(_a) {
    var backgroundColor = _a.backgroundColor, children = _a.children;
    return react_1.default.createElement(StyledWrapper, { backgroundColor: backgroundColor }, children);
}
exports.default = FlowWrapper;
var StyledWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  background-color: ", ";\n  min-height: 100vh;\n"], ["\n  background-color: ", ";\n  min-height: 100vh;\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor || 'none';
});
var templateObject_1;
//# sourceMappingURL=flow-wrapper.js.map